import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/apiServices';
 

// Async thunk for fetching users
export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
    const response = await apiService.get('users');
    return response.data;
});

// Async thunk for creating a user
export const createUser  = createAsyncThunk('users/createUser ', async (userData) => {
    const response = await apiService.post('users', userData);
    return response.data;
});

// Async thunk for updating a user
export const updateUser  = createAsyncThunk('users/updateUser ', async ({ id, userData }) => {
    const response = await apiService.put(`users/${id}`, userData);
    return response.data;
});

// Async thunk for deleting a user
export const deleteUser  = createAsyncThunk('users/deleteUser ', async (id) => {
    await apiService.delete(`users/${id}`);
    return id; // Return the id to remove it from the state
});

// Async thunk for requesting password reset
export const requestPasswordReset = createAsyncThunk('users/requestPasswordReset', async (email) => {
    const response = await apiService.post('users/request-password-reset', { email });
    return response.data;
});

// Async thunk for changing password
export const changePassword = createAsyncThunk('users/changePassword', async (passwordData) => {
    const response = await apiService.post('users/change-password', passwordData);
    return response.data;
});




const userSlice = createSlice({
    name: 'users',
    initialState: {
        users: [],
        loading: false,
        error: null,
        passwordResetSuccess: false,
        passwordChangeSuccess: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(requestPasswordReset.pending, (state) => {
            state.loading = true;
        })
        .addCase(requestPasswordReset.fulfilled, (state) => {
            state.loading = false;
            state.passwordResetSuccess = true;
        })
        .addCase(requestPasswordReset.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
        .addCase(changePassword.pending, (state) => {
            state.loading = true;
        })
        .addCase(changePassword.fulfilled, (state) => {
            state.loading = false;
            state.passwordChangeSuccess = true;
        })
        .addCase(changePassword.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.users.push(action.payload);
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                const index = state.users.findIndex(user => user._id === action.payload._id);
                if (index !== -1) {
                    state.users[index] = action.payload;
                }
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.users = state.users.filter(user => user._id !== action.payload);
            });
    },
});

export default userSlice.reducer;